import type { Deadline } from '@assessments/shared'

/** The deadline as shown on the overview's Deadline card and each assessment card. */
export function formatDeadline(deadline: Deadline): string {
  if (deadline.state === 'none' || !deadline.effectiveDeadline) return 'No deadline set'
  return new Date(deadline.effectiveDeadline).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}
